<template>
  <div class="kf-empty text-center py-10 px-4">
    <!-- `mdi-` prefixed names stay on Vuetify; anything else is a Lucide name. -->
    <v-icon v-if="isMdi" :size="56" color="#B0BEC5">{{ icon }}</v-icon>
    <LucideIcon v-else :name="icon" :size="48" color="#B0BEC5" :stroke-width="1.5" />
    <div class="kf-empty__title mt-4">{{ title }}</div>
    <div v-if="message" class="kf-empty__message mt-1">{{ message }}</div>
    <div v-if="$slots.action" class="mt-5">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "KfEmptyState",
  props: {
    title: { type: String, default: "Nothing to show" },
    message: { type: String, default: "" },
    icon: { type: String, default: "inbox" },
  },
  computed: {
    isMdi() {
      return String(this.icon).startsWith("mdi-");
    },
  },
};
</script>

<style scoped>
.kf-empty__title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
.kf-empty__message {
  font-size: var(--kf-fs-hint);
  color: #000;
  max-width: 420px;
  margin: 0 auto;
  line-height: 1.5;
}
</style>
